var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdFdefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2270_95284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0833 5.16699C15.2565 5.16699 12.9167 7.50683 12.9167 10.3337V23.2503C10.0621 23.2503 7.75 25.5624 7.75 28.417V41.3337C7.75 44.1882 10.0621 46.5003 12.9167 46.5003V51.667C12.9167 54.4938 15.2565 56.8337 18.0833 56.8337H49.0833C51.9102 56.8337 54.25 54.4938 54.25 51.667V19.1533C54.2499 18.4682 53.9776 17.8112 53.4932 17.3268L42.0902 5.92383C41.6058 5.43936 40.9488 5.16712 40.2637 5.16699H18.0833ZM18.0833 10.3337H38.75V18.0837C38.75 19.5097 39.9073 20.667 41.3333 20.667H49.0833V23.2503H18.0833V10.3337ZM12.9167 28.417H16.7917C18.9307 28.417 20.6667 30.153 20.6667 32.292C20.6667 34.431 18.9307 36.167 16.7917 36.167H15.5V41.3337H12.9167V28.417ZM36.1667 28.417H43.9167V31.0003H38.75V33.5837H42.8823V36.167H38.75V41.3337H36.1667V28.417ZM23.25 28.4775H27.458C31.5448 28.4775 33.5833 30.9355 33.5833 33.9167V35.9097C33.5833 38.927 31.5405 41.3337 27.4227 41.3337H23.25V28.4775ZM15.5 31.0003V33.5837H16.7917C17.5047 33.5837 18.0833 33.005 18.0833 32.292C18.0833 31.579 17.5047 31.0003 16.7917 31.0003H15.5ZM25.8333 31.0609V38.7503H27.4227C29.0554 38.7503 31 38.2553 31 35.9097V33.9167C31 31.5555 29.0752 31.0609 27.458 31.0609H25.8333ZM18.0833 46.5003H49.0833V51.667H18.0833V46.5003Z",
    fill: "black",
    fillOpacity: 0.54
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2270_95284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdFdefault);
export default __webpack_public_path__ + "static/media/PDF default.6d0c41575fbbb728ddc72a2a9577c376.svg";
export { ForwardRef as ReactComponent };